module.exports = __webpack_public_path__ + "static/media/03-01.9c9dd0e0.png";